<script>
import Vue from "vue";
import SortedTablePlugin from "vue-sorted-table";
import functions from "../../../util/functions.js";
import constants from "../../../util/constants";
import infosJoueur from "../../../components/joueurs/infos-joueur.vue";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});

export default {
  data: function () {
    return {
      constants,

      is_doing_action: false,
      action_message: "En cours",

      selected_code_joueur: "",

      sortBy: " ",
      perPage: 10,
      currentPage: 1,
      sortDesc: false,
      sortByFormatted: true,
      filterByFormatted: true,
      sortable: true,
      is_loading_joueurs: true,
      fields: [
        { key: "action", sortable: true },
        { key: "profil", sortable: false },
        { key: "prenom", sortable: true },
        { key: "nom", sortable: true },
        { key: "sexe", sortable: true },

        { key: "code_etat", sortable: true },
        { key: "matricule", sortable: true },
        { key: "numero_licence", sortable: true },
        { key: "matricule", sortable: true },
        { key: "numero_dorsale", sortable: true },
        { key: "position_terrain", sortable: true },
        { key: "pied_fort", sortable: true },

        { key: "taille", sortable: true },
        { key: "poids", sortable: true },

        { key: "biographie", sortable: true },

        { key: "club_provenance", sortable: true },
        { key: "date_recrutement", sortable: true },

        { key: "nationalite", sortable: true },
        { key: "date_naissance", sortable: true },
        { key: "lieu_naissance", sortable: true },
        { key: "nom_pere", sortable: true },
        { key: "nom_mere", sortable: true },
      ],
      all_joueurs: [],
      search_text: "",
    };
  },
  async created() {
    this.is_loading_joueurs = true;
    let url = this.constants.api_url + "/joueurs/pour-equipe";
    let response = await fetch(url, {
      method: "get",
      cache: "no-cache",
      headers: {
        Authorization: sessionStorage.getItem("token"),
      },
    });
    let data = await response.json();
    if (data.status == "SUCCESS") {
      this.all_joueurs = data.joueurs.map((joueur) => {
        return {
          ...joueur,
          sexe: joueur.sexe.toUpperCase(),
          profil: `<img
                  src="${
                    this.constants.api_base_url +
                    "/images/joueurs/profiles/" +
                    joueur.code_joueur +
                    ".jpg"
                  }"
                  alt="img" 
                  class="rounded-circle   border"
                />`,
          biographie: joueur.biographie.substr(0, 100) + "...",
          date_naissance:
            "Le " + this.obtenirDateEnFrancaisCourt(joueur.date_naissance),
          date_recrutement:
            "Le " + this.obtenirDateEnFrancaisCourt(joueur.date_recrutement),
          action: joueur.code_joueur,
        };
      });
    } else {
      this.$swal({
        type: "error",
        title: "Une erreur est survenue",
        text: "Status : " + data.status + "\nMessage : " + data.message,
        //footer: '<a href>Why do I have this issue?</a>'
      });
    }
    this.is_loading_joueurs = false;
  },
  computed: {
    rows() {
      return this.all_joueurs.length;
    },
    joueurs() {
      return this.all_joueurs.filter((joueur) => {
        if (this.search_text == "") {
          return this.all_joueurs;
        }
        let attrs = [
          "nom",
          "prenom",
          "nom_pere",
          "nom_mere",
          "matricule",
          "numero_licence",
          "sexe",
          "numero_dorsale",
          "position_terrain",
          "pied_fort",
          "taille",
          "poids",
          "biographie",
          "club_provenance",
          "nationalite",
          "code_etat",
          "lieu_naissance",
        ];
        for (let attr of attrs) {
          if (
            joueur[attr] != undefined &&
            joueur[attr]
              .toLowerCase()
              .toLowerCase()
              .includes(this.search_text.toLowerCase())
          ) {
            return true;
          }
        }
      });
    },
  },
  methods: {
    ...functions,
    async doDeleteJoueur(code_joueur) {
      let res = await this.$swal({
        title: "Supprimer ?",
        text: "Voulez-vous vraiment supprimer ce joueur ?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
      });
      if (!res.value) {
        return;
      }
      this.action_message = "Suppression du joueur en cours";
      this.is_doing_action = true;
      let url = this.constants.api_url + "/joueurs/" + code_joueur;
      let response = null;
      try {
        response = await fetch(url, {
          method: "delete",
          cache: "no-cache",
          body: JSON.stringify(this.joueur),
          headers: {
            Authorization: sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        });
      } catch (e) {
        this.$swal({
          type: "error",
          title: "La connexion au serveur a échoué",
          text: e.message,
          //footer: '<a href>Why do I have this issue?</a>'
        });
        return;
      }
      let data = await response.json();
      if (data.status == "SUCCESS") {
        this.all_joueurs = this.all_joueurs.filter(
          (joueur) => joueur.code_joueur != code_joueur
        );
        this.$swal({
          type: "success",
          title: "Effectué",
          text: "Le joueur a été supprimé avec succès. ",
          //footer: '<a href>Why do I have this issue?</a>'
        });
      } else {
        this.$swal({
          type: "error",
          title: "Une erreur est survenue",
          text: "Status : " + data.status + "<br/>Message : " + data.message,
          //footer: '<a href>Why do I have this issue?</a>'
        });
      }
      this.is_doing_action = false;
    },
  },
  components: {
    infosJoueur,
  },
};
</script>

<template>
  <section class="mt-5">
    <div class="page-header">
      <h3 class="page-title">Liste de Joueurs</h3>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:void(0);">Administration</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Liste de Joueurs
          </li>
        </ol>
      </nav>
    </div>
    <div v-if="!is_loading_joueurs">
      <div v-if="is_doing_action">
        <div class="card mb-4">
          <div class="card-body">
            <div class="circle-loader"></div>
            <p class="text-center mt-4">{{ action_message }}</p>
          </div>
        </div>
      </div>
      <div class=" ">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="card-title mb-5">Liste de Joueurs</h4> -->
            <div class="row d-flex justify-content-end">
              <div class="col-md-6">
                <button
                  type="button"
                  @click="$router.push('/admin/joueurs/nouveau')"
                  :disabled="is_doing_action"
                  class="btn-icon-text btn btn-primary mb-3 mb-md-0"
                >
                  <i class="fa fa-plus btn-icon-prepend"></i>
                  Nouveau Joueur
                </button>
              </div>
              <div class="col-md-6">
                <b-form-group label="" label-for="input5">
                  <b-form-input
                    type="text"
                    v-model="search_text"
                    placeholder="Rechercher"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="table-responsive">
              <b-table
                :items="joueurs"
                id="table-list"
                responsive
                :per-page="perPage"
                :current-page="currentPage"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
                <template v-slot:cell(status)="data">
                  <span v-html="data.value"></span>
                </template>
                <template v-slot:cell(action)="data">
                  <div class="d-flex justify-content-center">
                    <b-btn
                      variant="outline-dark"
                      class="py-1 mr-1 btn-sm"
                      title="Voir les informations sur ce joueur"
                      v-b-modal.modalinfos
                      @mouseenter="() => (selected_code_joueur = data.value)"
                      :disabled="is_doing_action"
                    >
                      <i class="fa fa-eye"></i>
                    </b-btn>
                    <button
                      class="btn btn-sm btn-outline-primary py-1 mr-1"
                      title="Modifier ce joueur"
                      @click="
                        () =>
                          $router.push('/admin/joueurs/editer/' + data.value)
                      "
                      :disabled="is_doing_action"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      @click="doDeleteJoueur(data.value)"
                      class="btn btn-sm btn-outline-danger py-1"
                      title="Supprimer ce joueur"
                      :disabled="is_doing_action"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </template>
                <template v-slot:cell(profil)="data">
                  <span v-html="data.value"></span>
                </template>
              </b-table>
              <div class="d-flex justify-content-center">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  aria-controls="table-list"
                  align="right"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5 pt-4" v-else>
      <div class="card">
        <div class="card-body">
          <div class="circle-loader"></div>
          <p class="text-center mt-4">Chargement des données en cours</p>
        </div>
      </div>
    </div>
    <div>
      <!-- Le modale -->
      <b-modal id="modalinfos" title="Détails sur le joueur" size="lg">
        <infos-joueur :code_joueur="selected_code_joueur" />
      </b-modal>
    </div>
  </section>
</template>
